import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/ar.svg'
import _imports_1 from '@/assets/us.svg'


const _hoisted_1 = {
  id: "formulario",
  class: "bg-gray-100 py-12",
  style: {"font-family":"PlexRegular"}
}
const _hoisted_2 = { class: "container mx-auto px-4 max-w-5xl pb-16" }
const _hoisted_3 = { class: "flex justify-center space-x-4 pb-5" }
const _hoisted_4 = {
  class: "font-bold text-gray-800 mb-4 text-2xl text-center pb-5",
  style: {"color":"rgb(41 57 152)","font-family":"PlexSemiBold"}
}
const _hoisted_5 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_6 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_7 = { class: "block mb-1" }
const _hoisted_8 = { class: "text-sm text-red-500 p-error" }
const _hoisted_9 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_10 = { class: "block mb-1" }
const _hoisted_11 = { class: "text-sm text-red-500 p-error" }
const _hoisted_12 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_13 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_14 = { class: "block mb-1" }
const _hoisted_15 = { class: "text-sm text-red-500 p-error" }
const _hoisted_16 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_17 = { class: "block mb-1" }
const _hoisted_18 = { class: "text-sm text-red-500 p-error" }
const _hoisted_19 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_20 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_21 = { class: "block mb-1" }
const _hoisted_22 = { class: "w-full px-2 md:w-2/12" }
const _hoisted_23 = { class: "block mb-1" }
const _hoisted_24 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_25 = { class: "block mb-1" }
const _hoisted_26 = { class: "text-sm text-red-500 p-error" }
const _hoisted_27 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_28 = { class: "block mb-1" }
const _hoisted_29 = { class: "text-sm text-red-500 p-error" }
const _hoisted_30 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_31 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_32 = { class: "block mb-1" }
const _hoisted_33 = { class: "text-sm text-red-500 p-error" }
const _hoisted_34 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_35 = { class: "block mb-1" }
const _hoisted_36 = { class: "text-sm text-red-500 p-error" }
const _hoisted_37 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_38 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_39 = { class: "block mb-1" }
const _hoisted_40 = { class: "text-sm text-red-500 p-error" }
const _hoisted_41 = { class: "flex flex-wrap py-2 mt-6" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_44 = { class: "pi pi-check mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSectionExtranjeros = _resolveComponent("HeaderSectionExtranjeros")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Form = _resolveComponent("Form")!
  const _component_BlockUI = _resolveComponent("BlockUI")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSectionExtranjeros),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.onSubmit,
        "validation-schema": _ctx.schema,
        class: "space-y-4 text-gray-700",
        onInvalidSubmit: _ctx.onInvalidSubmit
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.changeLanguage('es')), ["prevent"])),
                href: "#",
                class: "flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-200 rounded cursor-pointer transition-colors duration-200"
              }, _cache[12] || (_cache[12] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  class: "h-8"
                }, null, -1),
                _createElementVNode("span", { class: "font-semibold ml-2 text-gray-800" }, "Español", -1)
              ])),
              _createElementVNode("a", {
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.changeLanguage('en')), ["prevent"])),
                href: "#",
                class: "flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-200 rounded cursor-pointer transition-colors duration-200"
              }, _cache[13] || (_cache[13] = [
                _createElementVNode("img", {
                  src: _imports_1,
                  class: "h-8"
                }, null, -1),
                _createElementVNode("span", { class: "font-semibold ml-2 text-gray-800" }, "English", -1)
              ]))
            ]),
            _createElementVNode("h1", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.$t('title')), 1),
              _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('subtitle')), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('nombre')), 1),
                _createVNode(_component_Field, {
                  name: "nombre",
                  modelValue: _ctx.formData.nombre,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.nombre) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: _ctx.$t('nombre.placeholder'),
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_8, [
                      _createVNode(_component_ErrorMessage, { name: "nombre" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('apellido')), 1),
                _createVNode(_component_Field, {
                  name: "apellido",
                  modelValue: _ctx.formData.apellido,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.apellido) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: _ctx.$t('apellido.placeholder'),
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_11, [
                      _createVNode(_component_ErrorMessage, { name: "apellido" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('documento')), 1),
                _createVNode(_component_Field, {
                  name: "documento",
                  modelValue: _ctx.formData.documento,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.documento) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: _ctx.$t('documento.placeholder'),
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_15, [
                      _createVNode(_component_ErrorMessage, { name: "documento" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('mail')), 1),
                _createVNode(_component_Field, {
                  name: "mail",
                  modelValue: _ctx.formData.mail,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.mail) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: _ctx.$t('mail.placeholder'),
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_18, [
                      _createVNode(_component_ErrorMessage, { name: "mail" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('pais.telefono')), 1),
                _createVNode(_component_Select, {
                  modelValue: _ctx.selectedPhoneCountry,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedPhoneCountry) = $event)),
                  filter: "",
                  options: _ctx.paisesAll,
                  optionLabel: "value",
                  placeholder: _ctx.$t('pais.residencia.placeholder'),
                  class: "input-base"
                }, null, 8, ["modelValue", "options", "placeholder"])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('codigo.pais')), 1),
                _createVNode(_component_InputText, {
                  type: "text",
                  "model-value": _ctx.selectedPhoneCountry ? _ctx.selectedPhoneCountry.code : '',
                  class: "input-base",
                  readonly: ""
                }, null, 8, ["model-value"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('codigo.area')), 1),
                _createVNode(_component_Field, {
                  name: "codigoArea",
                  modelValue: _ctx.formData.codigoArea,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.codigoArea) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: _ctx.$t('codigo.area.placeholder'),
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_26, [
                      _createVNode(_component_ErrorMessage, { name: "codigoArea" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('telefono.celular')), 1),
                _createVNode(_component_Field, {
                  name: "telefonoCelular",
                  modelValue: _ctx.formData.telefonoCelular,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.telefonoCelular) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: _ctx.$t('telefono.celular.placeholder'),
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_29, [
                      _createVNode(_component_ErrorMessage, { name: "telefonoCelular" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t('pais.residencia')), 1),
                _createVNode(_component_Field, {
                  name: "pais",
                  modelValue: _ctx.selectedCountry,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedCountry) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                    _createVNode(_component_Select, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      filter: "",
                      options: _ctx.paises,
                      optionLabel: "value",
                      placeholder: _ctx.$t('pais.residencia.placeholder'),
                      class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value, 'input-error': errors.length > 0 }])
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "placeholder", "class"]),
                    _createElementVNode("span", _hoisted_33, [
                      _createVNode(_component_ErrorMessage, { name: "pais" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t('empresa')), 1),
                _createVNode(_component_Field, {
                  name: "empresa",
                  modelValue: _ctx.formData.empresa,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.empresa) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: _ctx.$t('empresa.placeholder'),
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_36, [
                      _createVNode(_component_ErrorMessage, { name: "empresa" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t('industria')), 1),
                _createVNode(_component_Field, {
                  name: "industria",
                  modelValue: _ctx.formData.industria,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.industria) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: _ctx.$t('industria.placeholder'),
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_40, [
                      _createVNode(_component_ErrorMessage, { name: "industria" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("button", {
                type: "submit",
                class: "px-6 py-3 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded-lg cursor-pointer transition-colors duration-350",
                disabled: _ctx.isSubmitting
              }, [
                _withDirectives(_createElementVNode("i", _hoisted_43, null, 512), [
                  [_vShow, _ctx.isSubmitting]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_44, null, 512), [
                  [_vShow, !_ctx.isSubmitting]
                ]),
                _createTextVNode(_toDisplayString(_ctx.$t('aceptar')), 1)
              ], 8, _hoisted_42)
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "onInvalidSubmit"]),
      _createVNode(_component_BlockUI, {
        blocked: _ctx.isSubmitting,
        fullScreen: ""
      }, null, 8, ["blocked"])
    ])
  ], 64))
}